/**
 * QuickActions — Phase 16.2 compact tile strip (52px height per spec).
 *
 * Single-line tiles: 16px icon + 12px label. Tiles are inline-flex and
 * wrap on narrow viewports. All targets are routes that auto-open a
 * dialog via the `?new=1` query convention.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Send, UserPlus, Receipt } from 'lucide-react';

const ACTIONS = [
  // QuickActions tiles. Each routes either to a dedicated /new page
  // (CreateQuote) or to a list page that auto-opens its New <X> dialog
  // via the `?new=1` query convention (CompactInvoicesList, Leads).
  { to: '/leads?new=1',    label: 'New Lead',      icon: UserPlus, testId: 'quick-new-lead' },
  { to: '/quotes/new',     label: 'New Quote',     icon: Plus,     testId: 'quick-new-quote' },
  { to: '/invoices?new=1', label: 'New Invoice',   icon: Receipt,  testId: 'quick-new-invoice' },
  { to: '/finance/invoices?status=outstanding', label: 'Send Reminder', icon: Send, testId: 'quick-send-reminder' },
];

const QuickActions = () => (
  <div
    className="flex items-center gap-2 flex-wrap"
    data-testid="quick-actions"
  >
    {ACTIONS.map((a) => <Tile key={a.testId} {...a} />)}
  </div>
);

const Tile = ({ to, label, icon: Icon, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="inline-flex items-center gap-2 px-3 bg-white border border-slate-200 rounded-[10px] shadow-sm hover:shadow-md hover:border-emerald-300 hover:bg-emerald-50/40 transition-all"
    style={{ height: 52 }}
  >
    <Icon className="h-4 w-4 text-emerald-700 shrink-0" />
    <span className="text-[12px] font-semibold text-slate-800 whitespace-nowrap">{label}</span>
  </Link>
);

export default QuickActions;
